<template>
  <div class="home__services">
    <div class="home__services--wrap">
      <h2 class="home__services--title">{{ $t("homeTranslate.homeServicesTitle") }}</h2>
      <p class="home__services--subtitle">{{ $t("homeTranslate.homeServicesSubtitle") }}</p>
      <ul class="home__services--serviceslist">
        <router-link to="/services" tag="li">
          <span>{{ $t("homeTranslate.homeServicesService1") }}</span>
        </router-link>
        <router-link to="/services" tag="li"><span>{{ $t("homeTranslate.homeServicesService2") }}</span></router-link>
        <router-link to="/services" tag="li"><span>{{ $t("homeTranslate.homeServicesService3") }}</span></router-link>
        <router-link to="/services" tag="li"><span>{{ $t("homeTranslate.homeServicesService4") }}</span></router-link>
        <router-link to="/services" tag="li"><span>{{ $t("homeTranslate.homeServicesService6") }}</span></router-link>
      </ul>
      <div class="home__services--block home__services--block--1"></div>
      <div class="home__services--block home__services--block--2"></div>
      <router-link class="home__services--link" to="/services" tag="a">{{ $t("homeTranslate.homeServicesRouterLink") }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home-services',
  data () {
    return {
      locale: 'en'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>

<style lang="css">
</style>
